var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { actionClass } from "@ane/legacy/lib/decorators/ReduxDecorators";
import mdsDataplaneResource from "@ane/exp-data/lib/resources/MdsDataplaneResource";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ConfigSectionActions = class {
  selectSection(activeSection) {
    return activeSection;
  }
  getSections() {
    return __async(this, null, function* () {
      return yield mdsDataplaneResource.getSections();
    });
  }
};
ConfigSectionActions = __decorateClass([
  actionClass("admin_app_module")
], ConfigSectionActions);
const configSectionActions = new ConfigSectionActions();
export {
  ConfigSectionActions,
  configSectionActions as default
};
//# sourceMappingURL=ConfigSectionActions.js.map
